<div class="p-grid p-p-2 divider-bottom">
    <div class="p-col-6 p-py-0 p-mt-1"
         *ngFor="let trackingHeader of trackingDetails?.trackingDetailsHeader | keyvalue: originalOrder">
        <div>
            <h6 class="p-my-1" style="min-width: max-content">
                {{trackingHeader?.key ? trackingHeader?.key : 'NA'}}
            </h6>
        </div>
        <div>
            {{trackingHeader?.value ? trackingHeader?.value : '-'}}
        </div>
    </div>
</div>

<div class="p-mt-3">
    <p-timeline [value]="trackingDetailsArray" align="left"
                class="tracking-timeline"
                styleClass="customized-timeline">
        <ng-template pTemplate="marker" let-event>
                    <span [class]="event?.enabled ? 'custom-marker' : 'custom-marker p-disabled fonts-opacity'"
                          style="border-radius: 5px;">
                        <img [src]="event.icon" alt="image-na">
                    </span>
        </ng-template>
        <ng-template pTemplate="content" let-event>
            <!--                | date : 'h:mm a'-->
            <p-card [class]="event?.enabled ? 'tracking-cards' :'tracking-cards p-disabled fonts-opacity' "
                    styleClass="p-mb-3 p-ml-2"
                    [header]="event.status"
                    [subheader]="(event.statusDateTime ? (event.statusDateTime | date: 'dd - MMM - yyyy h:mm a') : 'DD/MM/YYYY 00:00')">
                <img *ngIf="event.image" [src]="'assets/showcase/images/demo/product/' + event.icon"
                     [alt]="event.name" class="p-shadow-2"/>
            </p-card>
        </ng-template>
    </p-timeline>
</div>
